import { useEffect, useState } from 'react';
import JwtService from 'src/app/auth/services/jwtService';
import { getUserDeviceInfo } from 'src/app/helpers/utils';
import { useLoginWithMyIdMutation } from 'src/app/services/accountApi';
import { useTranslation } from 'react-i18next';
import useMessage from 'src/app/hooks/useMessage';
import { CircularProgress } from '@mui/material';

const { useSearchParams } = require('react-router-dom');

const SignInWithMyId = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [logInWithMyid, { isLoading }] = useLoginWithMyIdMutation();
  const { t } = useTranslation('translations');
  const { showMessage } = useMessage();
  const [isError, setIsError] = useState(false);

  const deviceInfo = getUserDeviceInfo();
  const reasonCode = searchParams.get('reason_code');

  useEffect(() => {
    const authCode = searchParams.get('code');
    const access_token = window.localStorage.getItem('jwt_access_token');
    if (authCode && !access_token) {
      logInWithMyid({
        authCode,
        deviceInfo,
        deviceType: 10345134,
      })
        .unwrap()
        .then((data) => {
          if (data.token) {
            JwtService.setSession(data.token);
            JwtService.setRefreshToken(data.refreshToken);
            JwtService.setRefreshTokenExpirationDate(data.refreshTokenExpiration);
            JwtService.handleAuthentication();
          }
        })
        .catch((error) => {
          setIsError(true);
          if (error.response.status === 401) {
            showMessage({ message: message, variant: 'warning' });
          }
          console.error(error);
        });
    }
  }, []);

  return (
    <div className="h-full flex justify-center items-center">
      <div className="w-[500px] max-w-[90%] py-[20px] px-[40px] rounded-6 flex flex-col justify-center items-center">
        <img
          alt="logo"
          src={`assets/images/logo/${process.env.REACT_APP_COMPANY_NAME}/logo.svg`}
          className="w-[150px] max-w-[80%] mb-20"
        />
        {isLoading && (
          <div className="text-[#004DA7] text-16">
            {t('GettingPermissionForEnter')}
            <CircularProgress
              size={20}
              sx={{
                color: 'currentColor',
              }}
            />
          </div>
        )}
        {(reasonCode || isError) && (
          <div className="text-center">
            <p className="mt-5">{t('MyIDAuthError')}</p>
            <a href={`https://${process.env.REACT_APP_DOMAIN_URI}`}>{t('BackToLoginPage')}</a>
          </div>
        )}
      </div>
    </div>
  );
};

export default SignInWithMyId;
